<template>

    <div class="w-full">

        <h4 class="mb-3 mt-6">Checkers</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addCheckerPrompt = true">Add checker</vs-button>

        <vx-card id="checkersDiv" class="vs-con-loading__container">

            <vs-table :data="tableData" class="mt-3" search>

                <template slot="thead">
                    <vs-th sort-key="id">Checker ID</vs-th>
                    <vs-th sort-key="provider_name">Provider</vs-th>
                    <vs-th sort-key="last_successful_check">Last check</vs-th>
                    <vs-th sort-key="last_check_time">Last check duration</vs-th>
                    <vs-th sort-key="status">Status</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].id">
                            {{ data[index].id }}
                        </vs-td>

                        <vs-td :data="data[index].provider_name">
                            {{ data[index].provider_name }}
                        </vs-td>

                        <vs-td :data="data[index].last_successful_check">
                            {{ data[index].last_successful_check }}
                        </vs-td>

                        <vs-td :data="data[index].last_check_time">
                            {{ data[index].last_check_time }}
                        </vs-td>

                        <vs-td>
                            <vs-chip v-if="data[index].status === 1 && !data[index].disabled" color="success">Online</vs-chip>
                            <vs-chip v-else-if="data[index].status === 0 || data[index].disabled" color="danger">Offline</vs-chip>
                            <vs-chip v-else color="warning">Unknown</vs-chip>
                        </vs-td>

                        <vs-td style="width: 165px">
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-play" color="success" class="md:mb-0 mr-1 mb-1" v-if="data[index].disabled" @click="enableChecker(data[index].id)"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-pause" color="warning" class="md:mb-0 mr-1 mb-1" v-if="!data[index].disabled" @click="disableChecker(data[index].id)"/>
                            <vs-button style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-trash-2" color="danger" class="md:mb-0 mr-1 mb-1" @click="removeChecker(data[index].id)"/>
                        </vs-td>

                    </vs-tr>
                </template>

            </vs-table>

        </vx-card>

        <vs-popup title="Add checker" :active.sync="addCheckerPrompt">
            <div id="addCheckerDiv" class="vs-con-loading__container" >

                <h5>Provider</h5>
                <vs-select autocomplete class="w-full" v-model="addObject['iptv_provider_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in providers" />
                </vs-select>

                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" :disabled="!(addObject['iptv_provider_id'] > 0)" @click="addChecker">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {
        props: {
            workerId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                checkers: [],
                providers: [],

                addObject: {},

                updateDataTimer: null,

                addCheckerPrompt: false

            }
        },
        methods: {

            loadData() {
                this.$vs.loading({
                    container: '#checkersDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/' + this.workerId + '/checker')
                loadPromise.then(function(response) {
                    thisIns.checkers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                const providerPromise = this.$http.get('/api/management/v1/provider')
                providerPromise.then(function(response) {
                    thisIns.providers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                Promise.all([loadPromise, providerPromise]).finally(function() {
                    thisIns.$vs.loading.close('#checkersDiv > .con-vs-loading')
                    if (!thisIns.updateDataTimer) {
                        thisIns.updateDataTimer = setInterval(() => { thisIns.updateData() }, 10000)
                    }
                })
            },
            updateData() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/worker/' + this.workerId + '/checker')
                loadPromise.then(function(response) {
                    if (JSON.stringify(thisIns.checkers) !== JSON.stringify(response.data)) {
                        thisIns.checkers = response.data
                    }
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            },
            addChecker() {
                this.$vs.loading({
                    container: '#addCheckerDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/worker/' + this.workerId + '/checker', {
                    iptv_provider_id: this.addObject.iptv_provider_id
                })

                addPromise.then(function() {
                    thisIns.$nextTick(function() {
                        thisIns.addCheckerPrompt = false
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addCheckerDiv > .con-vs-loading')
                })
            },
            disableChecker(id) {
                this.$vs.loading({
                    container: '#checkersDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const disablePromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/checker/' + id + '/disable')
                disablePromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.loadData()
                })
            },
            enableChecker(id) {
                this.$vs.loading({
                    container: '#checkersDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const disablePromise = this.$http.put('/api/management/v1/worker/' + this.workerId + '/checker/' + id + '/enable')
                disablePromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.loadData()
                })
            },
            removeChecker(id) {
                this.$vs.loading({
                    container: '#checkersDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const removePromise = this.$http.delete('/api/management/v1/worker/' + this.workerId + '/checker/' + id)
                removePromise.catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.loadData()
                })
            }
        },
        computed: {
            tableData() {
                const data = []

                for (let x = 0; x < this.checkers.length; x++) {
                    data.push({
                        id: this.checkers[x].id,
                        provider_name: this.checkers[x].provider_name,
                        last_successful_check: this.moment(this.checkers[x].last_successful_check).format('DD/MM/YYYY HH:mm:ss'),
                        last_check_time: this.checkers[x].last_check_time,
                        disabled: this.checkers[x].disabled,
                        status: this.checkers[x].status
                    })
                }

                return data
            }
        },
        beforeDestroy() {
            clearInterval(this.updateDataTimer)
        },
        mounted() {
            this.loadData()
        }

    }

</script>
